import { omit } from 'lodash'

export default class PromotionForm {
  constructor(data = {}, type) {
    const sell = data.sell || {}
    const stay = data.stay || {}

    this.name = data.name || null
    this.type = type || data.type || null
    this.mobileOnly = data.mobileOnly || false
    this.sellStartDate = sell.startDate || null
    this.sellEndDate = sell.endDate || null
    this.sellStartTime = sell.startTime || '00:00:00'
    this.sellEndTime = sell.endTime || '23:59:59'
    this.sellingDays = sell.sellingDays || [
      'SUNDAY',
      'MONDAY',
      'TUESDAY',
      'WEDNESDAY',
      'THURSDAY',
      'FRIDAY',
      'SATURDAY',
    ]
    this.stayStartDate = stay.startDate || null
    this.stayEndDate = stay.endDate || null
    this.stayingDays = stay.stayingDays || [
      'SUNDAY',
      'MONDAY',
      'TUESDAY',
      'WEDNESDAY',
      'THURSDAY',
      'FRIDAY',
      'SATURDAY',
    ]
    this.minimalNightStay = data.minimalNightStay || 1
    this.maximalNightStay = data.maximalNightStay || null
    this.minimalAdvancePurchase = data.minimalAdvancePurchase || null
    this.maximalAdvancePurchase = data.maximalAdvancePurchase || null
    this.percentDiscount = data.percentDiscount || 0
    this.ratePlans = data.ratePlans || []
    // this.roomTypes = data.roomTypes || []
    this.cancellationId = data.cancellationId || null
    this.promotionCode = data.promotionCode || ''
  }

  updatePayload() {
    return omit(this, 'type')
  }

  static validator() {
    return {
      name: 'required|min:3',
      type: 'required',
      mobileOnly: 'required',
      sellStartDate: 'required',
      sellEndDate: 'required',
      sellStartTime: 'required',
      sellEndTime: 'required',
      sellingDays: 'required',
      stayStartDate: 'required',
      stayEndDate: 'required',
      stayingDays: 'required',
      minimalNightStay: 'min_value:1',
      maximalNightStay: 'min_value:1',
      minimalAdvancePurchase: 'required|min_value:1',
      maximalAdvancePurchase: 'min_value:1',
      percentDiscount: 'required|min_value:1',
      ratePlans: 'required',
      // roomTypes: 'required',
      cancellationId: 'required',
    }
  }
}
